import type { HttpTypes } from "@medusajs/types";
import type { FetchError } from "@repo/api-sdk";
import sdk from "@repo/api-sdk";
import type { UseMutationOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";

export const useSignInWithEmailPass = (
  options?: UseMutationOptions<
    | string
    | {
        location: string;
      },
    FetchError,
    HttpTypes.AdminSignUpWithEmailPassword
  >
) => {
  return useMutation({
    mutationFn: (payload) => sdk.auth.login("customer", "emailpass", payload),
    ...options
  });
};
